module.exports = __webpack_public_path__ + "static/media/book9.e33419fd.jpg";